import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Args {
  projectId: string
  taskId: string
  newProjectId: string
}

export function useMoveTaskToProjectMutation() {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["move-task-to-project"],
    async (args: Args) => {
      const response = await apiClient.moveTaskToProject(args)

      if (!response.ok) {
        throw response.errors
      }

      return { task: response }
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["project-sections", variables.projectId])
        queryClient.invalidateQueries(["project-sections", variables.newProjectId])
        queryClient.invalidateQueries(['project-task', variables.projectId, variables.taskId])
      }     
    }
  )

  return mutation
}